/* eslint-disable jsx-a11y/anchor-is-valid */
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Box, Stack } from '@mui/material';
import { FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react-otp-input';
import CallImage from '../../../assets/images/call.png';
import OTPImage from '../../../assets/images/one-time-p.png';
import { OTPTypes } from '../../../constants/otpTypes';
import { FormHelper } from '../../../helpers/formHelper';
import { getUser, loginUsingToken } from '../../../services/authService';
import { OtpService } from '../../../services/otpService';
import { DialogWrapper } from '../../../shared/components/common/dialogWrapper';
import { Toaster } from '../common/toaster';
import { ButtonWrapper } from '../../../shared/components/formUtilities/useButton';
import { InternationalPhone } from '../../../shared/components/formUtilities/useInternationalPhone';
import { TextWrapper } from '../../../shared/components/formUtilities/useTextWrapper';
import { OTPAuthenticationSchema } from '../../../shared/validations/schema';

export const OTPAuthenticationDialog = ({
	state,
	onClose = (e) => { },
	isUnAuth = false,
	roles = [],
	userEmail = '',
	corrolationId = '',
	type = '',
}) => {
	const otpService = new OtpService();
	const [OTP, setOTP] = useState('');
	const [loading, setLoading] = useState(false);
	const [counter, setCounter] = useState(0);
	const [mobileNumber, setMobileNumber] = useState(null);
	const [showChangeMobile, setShowChangeMobile] = useState(false);
	const { t } = useTranslation();
	const user = getUser();
	const form = useFormik({
		initialValues: {
			contactNumber: '',
		},
		validationSchema: OTPAuthenticationSchema,
		...FormHelper.formikProps(),
	});

	useEffect(() => {
		onSendOTP();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);

	useEffect(() => {
		counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
	}, [counter]);

	const onVerify = (form) => {
		setLoading(true);
		if (!isUnAuth) {
			otpService
				.verifyOTP(form)
				.then((resp) => {
					setLoading(false);
					afterSuccessOTP(resp.data);
					Toaster({ msg: t('otpVerficationSuccess'), isError: false });
				})
				.catch((err) => { setLoading(false); });
		} else {
			form['UserEmail'] = userEmail;
			otpService
				.unAuthVerifyOTP(form)
				.then((resp) => {
					afterSuccessOTP(resp.data);
					setLoading(false);
				})
				.catch((err) => { setLoading(false); });
		}
	};

	const isApproved = () => {
		return !isUnAuth ? user?.isApproved : true;
	};

	const sendOTP = () => {
		if (isUnAuth) {
			return otpService.unAuthSendOTP(corrolationId, type, userEmail);
		} else {
			return otpService.sendOTP(corrolationId, type);
		}
	};

	const onSendOTP = () => {
		sendOTP()
			.then((resp) => {
				const phone = `${resp?.data?.phoneNumber?.code} ${resp?.data?.phoneNumber?.number}`;
				setMobileNumber(phone);
				form.setFieldValue('contactNumber', phone);
				setCounter(180);
			})
			.catch((err) => { });
	};

	const onResend = () => {
		onSendOTP();
	};

	const onSubmit = () => {
		if (OTP) {
			const form = {
				code: OTP,
				type: type,
			};
			onVerify(form);
		}
	};

	const afterSuccessOTP = (token) => {
		if (type === OTPTypes.Authentication) {
			loginUsingToken(token);
		}
		onClose(true);
	};

	const onChangeNumber = () => {
		setShowChangeMobile(true);
	};

	const onUpdateMobile = () => {
		let phoneNumber = form.values.contactNumber;
		if (phoneNumber) {
			let phone = {
				code: phoneNumber?.dialCode,
				number: phoneNumber?.number,
			};
			otpService
				.updateMobileNumber(phone)
				.then((resp) => {
					setCounter(0);
					setShowChangeMobile(false);
					onResend();
				})
				.catch((err) => { });
		}
	};

	const onBackToOTP = () => {
		setShowChangeMobile(false);
		form.resetForm();
	};

	const getOTPTextSection = () => {
		return (
			<Box className="text-center mb-6">
				{!showChangeMobile ? (
					<TextWrapper
						classList="!info-text !text-center"
						text={
							<p>
								{!mobileNumber ? (
									`${t('otpText')}`
								) : (
									<p>
										{t('otpText')}
										{!isApproved() && (
											<>
												<br></br>
												{mobileNumber}
												<a
													onClick={() => onChangeNumber()}
													className="mx-1 underline-link !text-[13px]">
													{t('wrongMobileNumber')}
												</a>
											</>
										)}
									</p>
								)}
							</p>
						}></TextWrapper>
				) : (
					<TextWrapper
						classList="!info-text !text-center"
						text={t('pleaseEnterYourMobileNumber')}></TextWrapper>
				)}
			</Box>
		);
	};

	const getOTPSection = () => {
		return (
			<Box className="!w-full">
				{!showChangeMobile ? (
					<Stack
						className="text-center"
						gap={2}>
						<TextWrapper
							classList="!info-text !font-semibold"
							text={t('verificationCode')}></TextWrapper>
						<Box className="flex justify-center">
							<OtpInput
								containerStyle="!grid grid-cols-4 gap-3 direction-ltr-toast otp-container"
								value={OTP}
								onChange={setOTP}
								shouldAutoFocus
								inputType='number'
								numInputs={4}
								renderInput={(props, index) => (
									<input
										{...props}
										autoComplete='one-time-code'
										style={{ appearance: "textfield", }}
										className='border-b-2 text-center p-2 nav-active focus-visible:!outline-none border-[#33CD87] rounded-sm !h-[40px] !w-[40px] !text-[20px]'
									/>
								)}
							/>
						</Box>
						<Box className="flex flex-col flex-0 items-center mt-2">
							{counter === 0 ? (
								<>
									<TextWrapper
										text={t('resendOtpText')}
										classList="!info-text"></TextWrapper>
									<a
										onClick={() => {
											onResend();
										}}
										className="underline-link !text-[13px]"
										style={{ width: 'fit-content' }}>
										{t('resend')}
									</a>
								</>
							) : (
								<Stack gap={2}>
									<Box className="flex flex-col py-2 px-3 items-center !primary-light-bg !rounded-md">
										<TextWrapper
											text={`${t('otpSuccessfullySent')}`}
											classList="!info-text !text-primary"></TextWrapper>
									</Box>
									<Box>
										<TextWrapper
											text={t('otpWillExpireIn')}
											classList="!info-text"></TextWrapper>
										<span className="text-primary mx-1">
											{Math.floor(counter / 60)}:{String(counter % 60).padStart(2, '0')}
										</span>
									</Box>
								</Stack>
							)}
						</Box>
					</Stack>
				) : (
					<Box className="mb-3">
						<FormikProvider value={form}>
							<InternationalPhone
								phoneWithCode={mobileNumber}
								name={'contactNumber'}
								key={'contactNumber'}
								label={'contactNumber'}></InternationalPhone>
						</FormikProvider>
					</Box>
				)}
			</Box>
		);
	};
	return (
		<>
			<DialogWrapper
				preventOutsideClick
				maxWidth="xs"
				width={'330px'}
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={
					<p className="text-[17px]">{`${showChangeMobile ? 'Change Mobile Number' : t('verifyAccount')
						}`}</p>
				}
				actionFooterClass="!px-0"
				content={
					<Box className="flex flex-col flex-0 justify-center items-center !text-sm">
						<Box className="nav-active flex justify-center items-center w-32 h-32 rounded-full mb-6 mt-3">
							<img
								className={`w-16 ${!showChangeMobile ? 'ml-[-10px]' : ''}`}
								src={showChangeMobile ? CallImage : OTPImage}
								alt="otpImage"></img>
						</Box>
						{getOTPTextSection()}
						{getOTPSection()}
					</Box>
				}
				actions={
					<Box className="!w-full">
						{!showChangeMobile ? (
							<Box className="flex items-center w-full">
								<ButtonWrapper
									classList="!w-full"
									loading={loading}
									disabled={!OTP || OTP?.length < 4}
									icon={<HowToRegOutlinedIcon></HowToRegOutlinedIcon>}
									type="button"
									onClick={() => {
										onSubmit();
									}}
									label={t('verify')}></ButtonWrapper>
							</Box>
						) : (
							<Box className="grid grid-cols-2 gap-2">
								<ButtonWrapper
									classList="!w-full"
									loading={loading}
									variant={'outlined'}
									icon={<ArrowBackIcon></ArrowBackIcon>}
									type="button"
									onClick={() => {
										onBackToOTP();
									}}
									label="Back"></ButtonWrapper>
								<ButtonWrapper
									classList="!w-full"
									loading={loading}
									disabled={!form.values.contactNumber}
									icon={<SaveOutlinedIcon></SaveOutlinedIcon>}
									type="button"
									onClick={() => {
										onUpdateMobile();
									}}
									label={t('update')}></ButtonWrapper>
							</Box>
						)}
					</Box>
				}></DialogWrapper>
		</>
	);
};
